import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from './useAuth';

export function useOnboardingStatus() {
  const { user } = useAuth();

  return useQuery({
    queryKey: ['onboarding-status', user?.id],
    queryFn: async () => {
      if (!user?.id) return { needsOnboarding: false };

      const { data: profile, error } = await supabase
        .from('profiles')
        .select('organization_id')
        .eq('user_id', user.id)
        .maybeSingle();

      if (error) throw error;

      // User needs onboarding if they don't have an organization
      return {
        needsOnboarding: !profile?.organization_id,
        profile,
      };
    },
    enabled: !!user?.id,
  });
}
